/* =============================================================================
   vp-gift-popup.js — Geschenk-Pop-up                               (20.10.2026)

   Gehoert zu sections/vp-gift-popup.liquid. Ablauf:

   1. Pruefen, ob das Pop-up ueberhaupt dran ist:
        - heutiges Datum IN WIEN liegt zwischen data-start und data-end
          (beide JJJJ-MM-TT, beide Tage zaehlen mit, leer = offen);
        - der Besucher hat es nicht innerhalb der letzten data-hours Stunden
          geschlossen (je Aktions-Kennung, in localStorage).
      Der Zeitraum wird hier im Browser geprueft und nicht per Liquid, weil
      Shopify Seiten zwischenspeichert: ein serverseitiges "heute" kann
      veraltet sein.
   2. Nach data-delay Sekunden oeffnen. Ist in dem Moment schon etwas anderes
      offen (Warenkorb-Schublade, Menue, Theme-Pop-up — das Theme markiert das
      mit body.hidden), wird gewartet, bis das Theme "body:visible" meldet.
   3. Schliessen per X, "Fenster schliessen", Klick daneben oder Escape. Beim
      Schliessen und beim Klick auf den Button wird die Wiedervorlage gemerkt.

   VORSCHAU: ?vp_geschenk=1 oeffnet das Pop-up sofort, ohne Zeitraum und ohne
   Wiedervorlage (fuer die Abnahme vor dem 21.10.).

   THEME-EDITOR: oeffnet sich beim Anklicken der Sektion, schliesst sich beim
   Verlassen; es wird nichts gemerkt.
   ========================================================================== */

(function () {
  'use strict';

  if (window.customElements && customElements.get('vp-gift-popup')) return;

  var TZ = 'Europe/Vienna';
  var PREVIEW = /[?&]vp_geschenk=1(?:&|$)/.test(window.location.search);

  function designMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  // Heutiges Datum in Wien als JJJJ-MM-TT. en-CA liefert genau dieses Format.
  function todayVienna() {
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit'
      }).format(new Date());
    } catch (e) {
      var d = new Date();
      var p = function (n) { return (n < 10 ? '0' : '') + n; };
      return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
    }
  }

  function validDate(s) { return /^\d{4}-\d{2}-\d{2}$/.test(s || ''); }

  function inWindow(start, end) {
    var today = todayVienna();
    if (validDate(start) && today < start) return false;
    if (validDate(end) && today > end) return false;
    return true;
  }

  function storageKey(campaign) { return 'vpGiftClosed:' + campaign; }

  function closedRecently(campaign, hours) {
    try {
      var t = parseInt(localStorage.getItem(storageKey(campaign)), 10);
      if (!(t > 0)) return false;
      return (Date.now() - t) < hours * 3600 * 1000;
    } catch (e) {
      return false;
    }
  }

  function remember(campaign) {
    try { localStorage.setItem(storageKey(campaign), String(Date.now())); } catch (e) {}
  }

  // Ist sonst etwas offen, das den Bildschirm belegt?
  function somethingElseOpen() {
    if (document.querySelector('.popup-wrapper.open')) return true;
    var cd = document.querySelector('cart-drawer');
    if (cd && cd.classList.contains('active')) return true;
    if (document.querySelector('.menu-drawer.open')) return true;
    return document.body.classList.contains('hidden');
  }

  class VpGiftPopup extends HTMLElement {
    connectedCallback() {
      // Die Sektion merken, bevor das Element umgehaengt wird (Theme-Editor
      // schickt seine Ereignisse an die Sektion).
      if (!this._section) this._section = this.closest('.shopify-section');

      // Das Element ans Ende von <body> haengen: die Footer-Sektion liegt in
      // Containern mit eigenem Stapelkontext, darin wuerde z-index nicht
      // greifen. Das Theme-Pop-up macht es beim Oeffnen genauso.
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
        return; // connectedCallback laeuft nach dem Umhaengen erneut
      }

      if (this._vpReady) return;
      this._vpReady = true;

      this.dialog = this.querySelector('.vp-gift__dialog');
      this.campaign = this.dataset.campaign || 'default';
      this.hours = parseInt(this.dataset.hours, 10) || 72;
      this.delay = Math.max(0, parseInt(this.dataset.delay, 10) || 0);

      this.onKey = this.onKey.bind(this);
      this.querySelectorAll('[data-vp-gift-close]').forEach(function (el) {
        el.addEventListener('click', this.close.bind(this, true));
      }, this);
      var cta = this.querySelector('[data-vp-gift-cta]');
      if (cta) cta.addEventListener('click', function () { remember(this.campaign); }.bind(this));

      if (designMode()) {
        var section = this._section;
        var self = this;
        if (section) {
          section.addEventListener('shopify:section:select', this.open.bind(this));
          section.addEventListener('shopify:section:deselect', this.close.bind(this, false));
          // Beim Neuaufbau der Sektion im Editor das alte, umgehaengte
          // Element entfernen, sonst stehen zwei Pop-ups im <body>.
          section.addEventListener('shopify:section:unload', function () {
            if (self.isOpen) document.body.classList.remove('hidden');
            self.remove();
          });
        }
        return;
      }

      if (!PREVIEW) {
        if (!inWindow(this.dataset.start, this.dataset.end)) return;
        if (closedRecently(this.campaign, this.hours)) return;
      }

      setTimeout(this.tryOpen.bind(this), PREVIEW ? 300 : this.delay * 1000);
    }

    tryOpen() {
      if (this.isOpen) return;
      if (somethingElseOpen()) {
        // Warten, bis Schublade/Menue/anderes Pop-up zu ist.
        var self = this;
        var later = function () {
          document.removeEventListener('body:visible', later);
          setTimeout(function () { if (!somethingElseOpen()) self.open(); }, 600);
        };
        document.addEventListener('body:visible', later);
        return;
      }
      this.open();
    }

    open() {
      if (this.isOpen) return;
      this.isOpen = true;
      this.lastFocus = document.activeElement;
      this.hidden = false;
      // Bild sofort laden, nicht erst wenn der Browser es "sieht"
      var img = this.querySelector('.vp-gift__img');
      if (img) img.loading = 'eager';
      document.body.classList.add('hidden');
      var self = this;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { self.classList.add('is-open'); });
      });
      document.addEventListener('keydown', this.onKey);
      setTimeout(function () {
        try { self.dialog.focus({ preventScroll: true }); } catch (e) { self.dialog.focus(); }
      }, 50);
    }

    close(rememberIt) {
      if (!this.isOpen) return;
      this.isOpen = false;
      if (rememberIt && !designMode() && !PREVIEW) remember(this.campaign);
      this.classList.remove('is-open');
      document.removeEventListener('keydown', this.onKey);
      var self = this;
      setTimeout(function () {
        self.hidden = true;
        // body.hidden nur freigeben, wenn nichts anderes mehr offen ist
        var cd = document.querySelector('cart-drawer');
        var other = document.querySelector('.popup-wrapper.open') ||
                    (cd && cd.classList.contains('active')) ||
                    document.querySelector('.menu-drawer.open');
        if (!other) {
          document.body.classList.remove('hidden');
          document.dispatchEvent(new CustomEvent('body:visible'));
        }
        if (self.lastFocus && self.lastFocus.focus) {
          try { self.lastFocus.focus({ preventScroll: true }); } catch (e) {}
        }
      }, 350);
    }

    onKey(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        this.close(true);
        return;
      }
      if (e.key !== 'Tab') return;
      // Fokus im Dialog halten
      var f = this.dialog.querySelectorAll('a[href], button:not([disabled])');
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === this.dialog)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  customElements.define('vp-gift-popup', VpGiftPopup);
})();
